function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14,2 C7.37096774,2 2,7.37096774 2,14 C2,20.6290323 7.37096774,26 14,26 C20.6290323,26 26,20.6290323 26,14 C26,7.37096774 20.6290323,2 14,2 Z M19.8935484,10.2209677 L17.9241935,19.5016129 C17.7790323,20.1596774 17.3870968,20.3193548 16.8403226,20.0096774 L13.8403226,17.7983871 L12.3935484,19.1919355 C12.233871,19.3516129 12.0983871,19.4870968 11.7887097,19.4870968 L12.0016129,16.433871 L17.5612903,11.4112903 C17.8032258,11.1983871 17.5080645,11.0774194 17.1887097,11.2903226 L10.3177419,15.616129 L7.35645161,14.6919355 C6.71290323,14.4887097 6.6983871,14.0483871 7.49193548,13.7387097 L19.0612903,9.27741935 C19.5983871,9.08387097 20.0677419,9.40806452 19.8935484,10.2209677 L19.8935484,10.2209677 Z",
  id: "Shape",
  fill: "#829AB1",
  fillRule: "nonzero"
});

var SvgAppTelegram = function SvgAppTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app_telegram.a8c7417f.svg";
export { ForwardRef as ReactComponent };